import EvalIncompletas from "pages/LandingPages/EvalIncompletas/evalIncompletas";

export default function EvalIncompletasPage() {
  return <EvalIncompletas />;
}
